import React, { useState, useEffect, useCallback } from "react"
import { useParams } from "react-router-dom"
import { X } from "lucide-react"
import { useAppCtx, appStore } from "lib/state"
import { queryTools, cn } from "lib/utils"
import { CollapsiblePanel, CollectionLoader, ElementEditorWrapper, ElementLoader } from "lib/components"
import SummaryTableRender from "./SummaryTableRender"
import { summary_table_data } from "./summary_table_data"

export default function SummaryTableEditor({ }: { }){

  const { tmplid } = useParams()
  const { store, AppStore }:any = appStore()

  const { data:_Template } = queryTools.resource.parseQueryForApi("template.findById", { _id: tmplid })
  const { data:_Elements } = queryTools.resource.parseQueryForApi("statement.findAll", {})

  const [ elementsAvailable, setElementsAvailable ] = useState<any[]>([])
  const [ selectedElement, setSelectedElement ] = useState<any>(null)
  const [ showEditor, setShowEditor ] = useState<boolean>(false)

  const handleLoaderSelect = (elem:any) => {
    console.log(elem)
    setSelectedElement(elem)
  }

  useEffect(() => {
    const client_id = _Template?.AssignedTo?._id || null
    if( _Elements ) setElementsAvailable(_Elements.filter((elem:any) => elem.element_type === store.element.refstr && (elem.client_id === null || elem.client_id === client_id)))
  },[_Elements])

  return (
  <div className="w-full flex flex-col justify-start items-start">
    { summary_table_data.map( (item:any) => (
      <div key={item.label} className="w-full flex items-center py-1">
        <div className="w-4/12 text-base font-semibold">{item.label}</div>
        <div className="w-8/12 text-base">{item.value}</div>
      </div>
    ))}
  </div>
  )
}